<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import './assets/styles/pure.css';
  import './assets/styles/grids-responsive.css';
  import './assets/styles/app.css';
  import './assets/styles/util.css';
  import './assets/styles/tag-classes.css';

  export default {
    name: 'app',
  };
</script>



// WEBPACK FOOTER //
// App.vue?bd71b520